import type { NextPage } from 'next'
import Link from 'next/link'

type Props = {
  hideFooter?: boolean
}

const Footer = ({ hideFooter = false }: Props) => {
  if (hideFooter) {
    return null
  }
  return (
    <footer
      className="py-[30px] px-0 bg-[#34414E] text-white text-center font-yu-gothic text-xs sp:py-[82px] sp:px-[41px]"
      id="likes-footer"
    >
      <div className="mx-auto w-[66.7%] text-left sp:w-full">
        <div>
          <div className="text-left mb-1">
            <div className="text-xs font-bold text-white border-l-[5px] border-white pl-2.5 mb-[3px] leading-6">
              <a
                href="https://she-inc.co.jp/"
                className="text-white no-underline hover:opacity-70"
              >
                SHE | ミレニアルライフコーチングカンパニー
              </a>
            </div>
            <div className="ml-[15px]">
              <ul className="flex list-none leading-8 flex-wrap mb-8">
                <li className="mr-[5px] flex-shrink-0">
                  <a
                    href="https://shelikes.jp/"
                    target="_blank"
                    rel="noreferrer"
                    className="text-xs text-white no-underline hover:opacity-70"
                  >
                    SHElikes
                  </a>
                </li>
                <li className="mr-[5px] flex-shrink-0">|</li>
                <li className="mr-[5px] flex-shrink-0">
                  <a
                    href="https://shares.shelikes.jp"
                    target="_blank"
                    rel="noreferrer"
                    className="text-xs text-white no-underline hover:opacity-70"
                  >
                    SHEshares
                  </a>
                </li>
                <>
                  <li className="mr-[5px] flex-shrink-0">|</li>
                  <li className="mr-[5px] flex-shrink-0">
                    <a
                      href="https://money.shelikes.jp/"
                      target="_blank"
                      rel="noreferrer"
                      className="text-xs text-white no-underline hover:opacity-70"
                    >
                      SHEmoney
                    </a>
                  </li>
                </>
                <li className="mr-[5px] flex-shrink-0">|</li>
                <li className="mr-[5px] flex-shrink-0">
                  <a
                    href="https://sheworks.shelikes.jp/?utm_source=likes&utm_medium=lp&utm_campaign=footer_202308"
                    target="_blank"
                    rel="noreferrer"
                    className="text-xs text-white no-underline hover:opacity-70"
                  >
                    SHE WORKS
                  </a>
                </li>
                <li className="mr-[5px] flex-shrink-0">|</li>
                <li className="mr-[5px] flex-shrink-0">
                  <a
                    href="https://shelikes.jp/landing_pages/prodesigner/?utm_source=likes&utm_medium=lp&utm_campaign=profooter"
                    target="_blank"
                    rel="noreferrer"
                    className="text-xs text-white no-underline hover:opacity-70"
                  >
                    SHElikes PRO デザイナー
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div>
          <div className="text-left mb-1">
            <div className="text-xs font-bold text-white border-l-[5px] border-white pl-2.5 mb-[3px] leading-6">
              SHEに関する情報
            </div>
            <div className="ml-[15px]">
              <ul className="flex list-none leading-8 flex-wrap mb-8">
                <li className="mr-[5px] flex-shrink-0">
                  <a
                    target="_blank"
                    href="https://she-inc.co.jp/about"
                    rel="noreferrer"
                    className="text-xs text-white no-underline hover:opacity-70"
                  >
                    運営会社
                  </a>
                </li>
                <li className="mr-[5px] flex-shrink-0">|</li>
                <li className="mr-[5px] flex-shrink-0">
                  <a
                    target="_blank"
                    href="https://she-inc.co.jp/common/agreement.html"
                    rel="noreferrer"
                    className="text-xs text-white no-underline hover:opacity-70"
                  >
                    利用規約集
                  </a>
                </li>
                <li className="mr-[5px] flex-shrink-0">|</li>
                <li className="mr-[5px] flex-shrink-0">
                  <a
                    target="_blank"
                    href="https://shelikes.jp/pricing"
                    rel="noreferrer"
                    className="text-xs text-white no-underline hover:opacity-70"
                  >
                    料金プラン
                  </a>{' '}
                </li>
                <li className="mr-[5px] flex-shrink-0">|</li>
                <li className="mr-[5px] flex-shrink-0">
                  <Link
                    href="https://shelikes.channel.io/workflows/707798"
                    className="text-xs text-white no-underline hover:opacity-70"
                  >
                    お問い合わせ
                  </Link>
                </li>
                <li className="mr-[5px] flex-shrink-0">|</li>
                <li className="mr-[5px] flex-shrink-0">
                  <a
                    target="_blank"
                    href="https://she-inc.co.jp/common/policy.html"
                    rel="noreferrer"
                    className="text-xs text-white no-underline hover:opacity-70"
                  >
                    プライバシーポリシー
                  </a>
                </li>
                <li className="mr-[5px] flex-shrink-0">|</li>
                <li className="mr-[5px] flex-shrink-0">
                  <a
                    target="_blank"
                    href="https://she-files-public.s3-ap-northeast-1.amazonaws.com/%E7%89%B9%E5%AE%9A%E5%95%86%E5%8F%96%E5%BC%95%E6%B3%95%E3%81%AB%E5%9F%BA%E3%81%A4%E3%82%99%E3%81%8F%E8%A1%A8%E7%A4%BA.pdf"
                    rel="noreferrer"
                    className="text-xs text-white no-underline hover:opacity-70"
                  >
                    特定商取引法に基づく表示
                  </a>
                </li>
                <li className="mr-[5px] flex-shrink-0">|</li>
                <li className="mr-[5px] flex-shrink-0">
                  <a
                    target="_blank"
                    href="https://sheinc.notion.site/SHE-d7b37bfd7fb64b4cbba5c0391b5e4041"
                    rel="noreferrer"
                    className="text-xs text-white no-underline hover:opacity-70"
                  >
                    顧客ハラスメントに関する方針
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div>
        <p>© SHE inc. All Rights Reserved.</p>
      </div>
    </footer>
  )
}

export default Footer
